import { ControlePH } from "./controle-pH";

export class ControlePHGroup {
    Code: string
    Date: Date
    SamplerPuid: string

    /** 
 **  1 a 3 Par Jour
 **  Ph 2 - 7 - 12
 **/
    PH2: ControlePH = new ControlePH()
    PH7: ControlePH = new ControlePH()
    PH12: ControlePH = new ControlePH()

    static mapFromJSON(json: any): ControlePHGroup {
        const cphg = new ControlePHGroup();

        cphg.Code = json.code;
        cphg.Date = json.date;
        cphg.SamplerPuid = json.samplerPuid;

        if (json.pH2) {
            cphg.PH2 = ControlePH.mapFromJSON(json.pH2);
        }

        if (json.pH7) {
            cphg.PH7 = ControlePH.mapFromJSON(json.pH7);
        }

        if (json.pH12) {
            cphg.PH12 = ControlePH.mapFromJSON(json.pH12);
        }

        return cphg
    }
}